import {Component, forwardRef, Input} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {DropdownOptionModel} from "../../../models/components/form-controls/dropdown-option.model";
import {FormControlBaseComponent} from "../form-control-base/form-control-base.component";

@Component({
    selector: "pcg-ng-dropdown",
    template: require('./dropdown.component.html'),
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DropdownComponent), multi: true},
    ]
})
export class DropdownComponent extends FormControlBaseComponent<any> {
    @Input()
    public title: string = "";

    @Input()
    public options: Array<DropdownOptionModel> = new Array<DropdownOptionModel>();

    public selectedOption: DropdownOptionModel;

    public get visibleOptions(): Array<DropdownOptionModel> {
        return this.options.filter(option => option !== this.selectedOption);
    }

    public constructor() {
        super(/*DEFAULT_VALUE*/null);
    }

    public handleClick(option: DropdownOptionModel): boolean {
        this.writeNewValue(option.value);
        return false;
    }

    public writeValue(value: any): void {
        super.writeValue(value);
        this.selectedOption = this.options.find(option => option.value === value);
    }
}
